module.exports = __webpack_public_path__ + "components/app-promo/static/intersport/2-b76ad945c522ea906da96f90b207aae0.png";